import '@babel/polyfill';
require('./bootstrap');

window._ = require('lodash');
window.Vue = require('vue');
window.Locale = require('./vue-i18n-locales.generated');
window.Croppie = require('croppie');

// router

import GettingStarted from './src/router/GettingStarted.js'

window.router = new VueRouter({
    routes: GettingStarted,
    mode: 'history',
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    }
});
import VueInternationalization from 'vue-i18n';

window.i18n = new VueInternationalization({
    messages: Locale,
});

router.beforeEach((to, from, next) => {

    // use the language from the routing param or default language
    let language = to.params.lang;
    if (language != 'lt' && language != 'ru') {
      language = 'en';
    }

    i18n.locale = language;
    next();

});

import VueToastr2 from 'vue-toastr-2';
import Multiselect from 'vue-multiselect';
import VueCookies from 'vue-cookies';
import VueRecaptcha from 'vue-recaptcha';
import { Spin, Radio, Checkbox, Switch } from 'ant-design-vue';
import 'ant-design-vue/lib/spin/style/index.css';
import 'ant-design-vue/lib/radio/style/index.css';
import 'ant-design-vue/lib/checkbox/style/index.css';
import 'ant-design-vue/lib/switch/style/index.css';

import VueRouter from 'vue-router';

import * as VueGoogleMaps from 'vue2-google-maps';

import Cleave from 'vue-cleave-component';
import VueTelInput from 'vue-tel-input';
// import { use } from 'vue/types/umd';

window.toastr = require('toastr');
window.VueRouter = VueRouter;

Vue.use(i18n, VueCookies, Spin, Radio, Cleave, Checkbox, Switch);
Vue.use(VueRouter);
Vue.use(VueTelInput);

Vue.use(VueToastr2, {
    showMethod: 'slideDown',
    hideMethod: 'slideUp',
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: false,
    positionClass: 'toast-bottom-center',
    preventDuplicates: false,
    showDuration: 300,
    hideDuration: 300,
    timeOut: 5000,
    extendedTimeOut: 3000
});

Vue.use(VueGoogleMaps, {
    load: {
      key: GOOGLE_MAPS_BROWSER_KEY,
      libraries: 'places', // This is required if you use the Autocomplete plugin
    },
    installComponents: true
  })

Vue.directive('click-outside', {
    bind: function (el, binding, vnode) {
        window.event = function (event) {
            if (!(el == event.target || el.contains(event.target))) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', window.event)
    },
    unbind: function (el) {
        document.body.removeEventListener('click', window.event)
    },
});

Vue.component('watch-demo', require('./components/WatchDemo.vue').default);
Vue.component('trial-ended-bar', require('./components/TrialEndedBar.vue').default);
Vue.component('uploader', require('./components/Uploader.vue').default);
Vue.component('self-uploader', require('./components/SelfUploader.vue').default);
Vue.component('photo-modal', require('./components/PhotoModal.vue').default);
Vue.component('confirmation-popup', require('./components/ConfirmationPopup.vue').default);
Vue.component('confirmation-popup-inner', require('./components/ConfirmationPopupInner.vue').default);
Vue.component('floor-plan', require('./components/FloorPlan.vue').default);
Vue.component('help-popup', require('./components/HelpPopup.vue').default);
Vue.component('menu-dropdown', require('./components/MenuDropdown.vue').default);
Vue.component('listing-dropdown', require('./components/ListingDropdown.vue').default);
Vue.component('country-select', require('./components/CountrySelect.vue').default);
Vue.component('card-form', require('./components/CardForm.vue').default);
Vue.component('button-dashboard', require('./components/buttons/Dashboard.vue').default);
Vue.component('cancel-plan', require('./components/CancelPlanPopup.vue').default);
Vue.component('dropdown', require('./components/Dropdown.vue').default);
Vue.component('getting-started', require('./components/before-register/GettingStarted.vue').default);
Vue.component('continue-editing-bar', require('./components/before-register/ContinueEditingBar.vue').default);
Vue.component('register-popup', require('./components/before-register/RegisterPopup.vue').default);
Vue.component('register', require('./components/before-register/Register.vue').default);
Vue.component('preview-bar', require('./components/PreviewBar.vue').default);
Vue.component('template-container', require('./components/TemplateContainer.vue').default);
Vue.component('mobile-not-supported', require('./components/MobileNotSupported.vue').default);
Vue.component('photo-gallery', require('./components/PhotoGallery.vue').default);
Vue.component('photo-crop', require('./components/PhotoCrop.vue').default);
Vue.component('embed-video', require('./components/EmbedVideo.vue').default);
Vue.component('embed-virtual-tour', require('./components/EmbedVirtualTour.vue').default);
Vue.component('select-media', require('./components/SelectMedia.vue').default);
Vue.component('video-tour', require('./components/VideoTour.vue').default);
Vue.component('virtual-tour', require('./components/VirtualTour.vue').default);
Vue.component('additional-documents', require('./components/remaining-info/AdditionalDocuments.vue').default);
Vue.component('schedule-showing', require('./components/remaining-info/ScheduleShowing.vue').default);
Vue.component('google-maps-autocomplete', require('./components/GoogleMapsAutocomplete.vue').default);

// Vue.component('getting-started', require('./components/before-register/SelectTemplate.vue').default);
Vue.component('customize-website', require('./components/before-register/CustomizeWebsite.vue').default);
Vue.component('preview-template', require('./components/before-register/PreviewTemplate.vue').default);

Vue.component('multiselect', Multiselect);
Vue.component('a-spin', Spin);
Vue.component('a-switch', Switch);
Vue.component('a-radio', Radio);
Vue.component('a-checkbox', Checkbox);
Vue.component('a-checkbox-group', Checkbox.Group);
Vue.component('a-radio-group', Radio.Group);
Vue.component('vue-recaptcha', VueRecaptcha);

Vue.component('cleave', Cleave);

window.draggable = require('vuedraggable');

var version = '1.19.12.23.1';
